import axios from "axios";
import { API_URL } from "./conection";

export const getFormsOptions = async () => {
  try {
    const res = await axios.get(`${API_URL}/forms-options`);
    return res.data;
  } catch (error) {
    console.error("❌ Error en getFormsOptions:", error.message);
    return {};
  }
};

export const saveFormsOptions = async (optionId, data) => {
  try {
    const _data = { ...data };
    delete _data.optionId;

    const payloadSize = new Blob([JSON.stringify(_data)]).size;
    console.log(`[saveFormsOptions] PUT optionId=${optionId}, payload=${(payloadSize / 1024).toFixed(1)} KB`);

    const res = await axios.put(`${API_URL}/save-forms-options/${optionId}`, _data,
    {
      headers: {
        "Content-Type": "application/json",
      },
      timeout: 60000,
    }
    );
    console.log(`[saveFormsOptions] ✓ Respuesta OK`);
    return res.data;
  } catch (error) {
    const isTimeout = error.code === "ECONNABORTED" || error.message?.includes("timeout");
    console.error(`[saveFormsOptions] ✗ ${isTimeout ? "TIMEOUT" : "ERROR"}:`, error.message || error);
    return null;
  }
};
